/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { Checkbox } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { useCreateWorkGroup } from "@/frameworks/core/hooks";

import * as S from "../emotion";

export default function SearchSettingField() {
	const {
		accessAllowType,
		allowSearch,
		handlers: { handleAllowSearch, handleAllowTypeChecker }
	} = useCreateWorkGroup();

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleAllowSearch(event.target.checked);
	};

	return (
		<S.FieldBox>
			<S.Name typoSize="Body4">{_T("추가 설정")}</S.Name>
			<Checkbox
				data-id="exclude"
				disabled={accessAllowType !== "PRIVATE"}
				checked={handleAllowTypeChecker(accessAllowType, allowSearch)}
				onChange={handleChange}
			>
				{_T("그룹 검색 제외")}
			</Checkbox>
		</S.FieldBox>
	);
}
